import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { getSpacing } from '../../../util/spacing.js';
import { selectToken } from '../../../util/tokenSelector.js';
import { useDirectionContext } from '../../../contexts/session/Locale.js';
import { useThemeContext } from '../../../contexts/session/Theme.js';
import { RadialLoaderStyled, RadialLoaderTrackStyled } from './Radial.styled.js';

var _excluded = ["size", "color", "percentage", "label", "live"];
/**
 * Radial loader indicates to user the loading state of a feature or button.
 */
var RadialLoader = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var size = props.size,
    color = props.color,
    percentage = props.percentage,
    label = props.label,
    live = props.live,
    rest = _objectWithoutProperties(props, _excluded);
  var direction = useDirectionContext();
  var theme = useThemeContext();
  var sizePx = selectToken(theme.icons, size === 's' ? '16' : '20');
  var stroke = selectToken(theme.borderwidth, '2');
  var spacing = getSpacing(props, direction, theme.spacing);
  var trackColor = selectToken(theme.background, color);
  var clampedPercentage = percentage !== undefined ? Math.min(Math.max(percentage, 1), 100) : undefined;
  var ariaProps = percentage !== undefined ? {
    role: 'progressbar',
    'aria-valuemin': percentage !== undefined ? 0 : undefined,
    'aria-valuenow': percentage,
    'aria-valuemax': percentage !== undefined ? 100 : undefined
  } : {
    role: 'alert',
    'aria-live': live
  };
  return /*#__PURE__*/React.createElement(RadialLoaderStyled, _extends({
    "aria-label": label
  }, rest, spacing, ariaProps, {
    ref: ref,
    viewBox: "0 0 22 22",
    width: sizePx,
    height: sizePx,
    $percentage: clampedPercentage
  }), /*#__PURE__*/React.createElement(RadialLoaderTrackStyled, {
    cx: "11",
    cy: "11",
    r: "10",
    stroke: trackColor,
    $percentage: clampedPercentage,
    strokeWidth: stroke,
    fill: "none"
  }));
});
RadialLoader.defaultProps = {
  size: 'm',
  color: 'deprecated.primary.brand',
  live: 'assertive'
};
var RadialLoaderMemoized = /*#__PURE__*/React.memo(RadialLoader);
RadialLoaderMemoized.displayName = 'RadialLoader';

export { RadialLoaderMemoized as RadialLoader };
//# sourceMappingURL=Radial.js.map
